import { Flex } from '@chakra-ui/react';
import { Text } from '@kula-ai/components';
import { Download01, File06 } from '@kula-ai/icons-core';
import { resolveAgentforgeHref } from '../../../helpers/agentforgeHref';
import type { DownloadBlockData } from '../../../types';

interface DownloadBlockProps {
  data: DownloadBlockData;
}

// Generated-artifact download card (report PDF / interactive HTML). The
// signed capability URL arrives in structured data — never re-typed by the
// LLM — so the link on this card is always the exact URL the backend minted.
export const DownloadBlock = ({ data }: DownloadBlockProps) => {
  if (!data?.url || !data?.name) return null;
  const href = resolveAgentforgeHref(data.url);

  return (
    <Flex
      align="center"
      gap="10px"
      px="12px"
      py="10px"
      borderRadius="10px"
      borderWidth="1px"
      borderColor="var(--secondary-200)"
      bg="base-white"
      maxW="420px"
      data-test-id="agentforge-download-block"
    >
      <Flex
        align="center"
        justify="center"
        w="32px"
        h="32px"
        borderRadius="8px"
        bg="var(--primary-50)"
        color="var(--primary-600)"
        flexShrink={0}
      >
        <File06 size={16} />
      </Flex>
      <Flex direction="column" minW={0} flex="1">
        <Text variant="label" as="span" truncate>
          {data.name}
        </Text>
        {data.format && (
          <Text
            variant="small"
            as="span"
            className="text-secondary-500 uppercase"
          >
            {data.format}
          </Text>
        )}
      </Flex>
      <Flex
        as="a"
        // Chakra's `as` polymorphism loses the anchor attrs in TS; runtime is a plain <a>.
        {...({ href, target: '_blank', rel: 'noopener noreferrer' } as Record<
          string,
          string
        >)}
        align="center"
        gap="6px"
        px="10px"
        py="6px"
        borderRadius="8px"
        borderWidth="1px"
        borderColor="var(--secondary-200)"
        color="var(--secondary-700)"
        _hover={{ bg: 'secondary-50' }}
        flexShrink={0}
        data-test-id="agentforge-download-link"
      >
        <Download01 size={14} />
        <Text variant="small" as="span" className="font-medium">
          Download
        </Text>
      </Flex>
    </Flex>
  );
};
